import React from 'react';
import { useApolloClient } from '@apollo/client';

import { OpenCommerceUserCurrentDocument } from '@occc/graphql';
import { createFlagsClient, FlagsProvider } from '@occc/data-flags';

import { selectFlags } from '@occc/feat-feature-flag-control';

import { createApolloFlagSource } from './create-apollo-flag-source';

type FlagsBootstrapProps = {
  children: React.ReactNode;
};

export const FlagsBootstrap = ({ children }: FlagsBootstrapProps) => {
  const apolloClient = useApolloClient();

  const [flagsClient] = React.useState(() => {
    const source = createApolloFlagSource(
      apolloClient,
      OpenCommerceUserCurrentDocument,
      selectFlags,
    );

    return createFlagsClient({ source });
  });

  return <FlagsProvider client={flagsClient}>{children}</FlagsProvider>;
};
